export default __webpack_public_path__ + "static/media/PartsImportSample.d40b7f02.xlsx";